import { companyApis } from '@apis/dashboard/companyApis';
import { useQuery } from '@hooks/useQuery';

export const useCompanyDelegation = (id: number) => {
  return useQuery([`/dashboard/company/${id}/delegation/`], () =>
    companyApis
      .get('/dashboard/company/{id}/delegation/', {
        path: { id },
      })
      .then((r) => r[200]!),
  );
};
